import React from 'react';
import { MainWrapper } from './Homepage.style';
import { observer } from 'src/utils/mobx-react';
import { LayoutSkeleton } from 'src/domains/layouts/webview/modules/LayoutSkeleton';
import { HomeRouteType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { RightHandSideViewType } from 'src/domains/layouts/state/router/newRouter/rhsRouteType';
import { HomepageContent } from 'src/domains/layouts/layouts/homepage/HomepageContent';

interface HomePageLayoutPropsType {
    currentView: HomeRouteType;
    isSearchActive: boolean;
    accountView: RightHandSideViewType | null;
}

export const HomePageLayout = observer(
    'HomePageLayout',
    ({ currentView, isSearchActive, accountView }: HomePageLayoutPropsType) => {
        return (
            <MainWrapper className='homepage'>
                <LayoutSkeleton
                    currentView={currentView}
                    accountView={accountView}
                    isSearchActive={isSearchActive}
                    navigationType='global'
                >
                    <HomepageContent />
                </LayoutSkeleton>
            </MainWrapper>
        );
    }
);
